var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"row"},[_c('dt',{staticClass:"col-4"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.input.length > 0)?_c('dd',{staticClass:"col-8",domProps:{"innerHTML":_vm._s(_vm.input)}}):_c('dd',{staticClass:"col-8"},[_vm._v("N/A")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e0c42aa","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/My/components/Profile/ProfileRow.vue
// module id = null
// module chunks = 